import {
  Component,
  OnInit,
  Inject,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";
import { CrudService } from "src/app/Services/crud.service";
import { Observable } from "rxjs";
import { debounceTime, distinctUntilChanged, map } from "rxjs/operators";
import { FormStateService } from "src/app/Services/form.service";
import { LoadingService } from "src/app/Services/loading.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-add-edit-screen",
  templateUrl: "./add-edit-screen.component.html",
  styles: [
    `
      .invalid-label {
        color: red;
      }
    `,
  ],
  standalone: false,
})
export class AddEditScreenComponent implements OnInit {
  form: UntypedFormGroup;
  @Output() formvalue = new EventEmitter<any>();
  moduleList: any;
  roleList: any;
  constructor(
    private toastr: ToastrService,
    private crudService: CrudService,
    private formBuilder: UntypedFormBuilder,
    private translateService: TranslateService,
    private formStateService: FormStateService,
    private loadingService: LoadingService,
    public activeModal: NgbActiveModal
  ) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
  }
  @Input() data: any = {};
  // data: any;
  ngOnInit() {
    this.form = this.formBuilder.group({
      name: [this.data.name || "", Validators.required],
      url: [this.data.url || "", Validators.required],
      description: [this.data.description || ""],
      module: [this.data.module || ""],
      displayOrder: [this.data.displayOrder || ""],
      roles: [this.data.roles || ""],
    });
    this.form.valueChanges.subscribe(() => {
      if (this.form.dirty) {
        this.formStateService.setFormDirty();
      }
    });
    this.getScreensNumber();
    this.getModuleList();
    this.getRoleList();
  }

  getScreensNumber() {
    let self = this;
    let query = `filter[where][projectId]=${self.data.projectId}`;

    self.crudService.get(
      null,
      function (response) {
        if (response && response.length) {
          /*  if (response[0]["roles"] != "") {
            self.form.get("roles").setValue(response[0]["roles"]);
          }
 */
          if (!self.data.displayOrder) {
            self.form.patchValue({ displayOrder: response.length + 1 });
          }
        }
      },
      "screenManagements?" + query
    );
  }

  getModuleList() {
    let self = this;
    let query = `filter[where][projectManagementId]=${self.data.projectId}&filter[order]=name ASC`;

    self.crudService.get(
      null,
      function (response) {
        if (response && response.length) {
          self.moduleList = response;
        } else {
          self.moduleList = [];
        }
      },
      "modules?" + query
    );
  }

  getRoleList() {
    let self = this;
    let query = `filter[where][projectManagementId]=${self.data.projectId}&filter[order]=name ASC`;

    self.crudService.get(
      null,
      function (response) {
        if (response && response.length) {
          self.roleList = response;
        } else {
          self.roleList = [];
        }
      },
      "appRoles?" + query
    );
  }

  onNoClick(): void {
    // this.dialogRef.close(false);
    this.formStateService.clearFormDirty();
  }

  onSubmit(): void {
    this.formStateService.clearFormDirty();
    Object.keys(this.form.controls).forEach((controlName) => {
      this.form.get(controlName).markAsTouched();
    });

    if (this.form.valid) {
      // this.dialogRef.close(this.form.value);
      this.activeModal.close(this.form.value);
      this.loadingService.hide();
      this.form.reset();
    } else {
      if (this.form.get("name").hasError("required")) {
        this.toastr.error("Name is required", "Invalid Operation");
      } else if (this.form.get("url").hasError("required")) {
        this.toastr.error("URL is required", "Invalid Operation");
      }
    }
  }
  closeModal() {
    this.activeModal.close(this.form.value); // close modal (value not used here)
  }
}
